module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="no-tours-banner" style="display: none">\r\n	<div class="no-tours-banner__container">\r\n		<div class="no-tours-banner__content">\r\n			<div class="no-tours-banner__icon"></div>\r\n			<div class="no-tours-banner__text">\r\n				<div class="no-tours-banner__title"></div>\r\n				<div class=\'js-epoxy-havePriceCalendar\'></div>\r\n				<div class=\'js-epoxy-haveNotPriceCalendar\'>\r\n					<p>Рекомендуем изменить критерии</p>\r\n					<ul class="no-tours-banner__links"></ul>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>';
}
return __p;
};
